import React, { Component } from 'react';
import classnames from 'classnames';
import Constants from '../../../Constants';
import Menu from '../../../components/elements/menu/Menu';
import { StatusIconActive, StatusIconPaused } from '../../elements/icons/StatusIcons';
import { ReactComponent as DetailsIcon } from 'new/components/icons/fi-rr-info.svg';

class APIKeyDetailActions extends Component {
  constructor(props) {
    super(props);

    this._handleRotateClicked = this._handleRotateClicked.bind(this);
    this._handlePauseClicked = this._handlePauseClicked.bind(this);
    this._handleActivateClicked = this._handleActivateClicked.bind(this);
    this._handleDeleteClicked = this._handleDeleteClicked.bind(this);
  }

  render() {
    const { data, showStatus, isPausing, isActivating, isRotating, hideMenuDetails } = this.props;
    const status = data.status;
    let statusClass;
    let menuItems = [];

    if (!hideMenuDetails) {
      menuItems.push({
        label: 'Details',
        icon: <DetailsIcon />,
        onClick: this._handleOpenDetails,
      });
    }

    menuItems.push({
      type: 'dialog',
      label: isRotating ? 'Rotating...' : 'Rotate',
      icon: (
        <i
          className="fa fa-refresh"
          style={{
            color: '#6D7E8F',
            fontSize: 19,
          }}
          aria-hidden="true"
        />
      ),
      disable: isRotating,
      dialogMessage: `Please confirm you want to rotate the API key for resource: ${data.name} (API Key ID: ${data.id})`,
      discardLabel: 'Cancel',
      confirmLabel: 'Rotate',
      onClick: this._handleRotateClicked,
    });

    switch (status) {
      case Constants.SourceStatus.ACTIVE:
        statusClass = 'status-active';
        menuItems.push({
          label: isPausing ? 'Pausing...' : 'Pause',
          icon: <StatusIconPaused />,
          disable: isPausing,
          onClick: this._handlePauseClicked,
        });
        break;

      case Constants.SourceStatus.PAUSED:
        statusClass = 'status-paused';
        menuItems.push({
          label: isActivating ? 'Activating...' : 'Activate',
          icon: <StatusIconActive />,
          disable: isActivating,
          onClick: this._handleActivateClicked,
        });
        break;

      default:
    }

    let deleteMenuItem = {
      type: 'dialog',
      label: 'Delete',
      icon: (
        <i
          className="fa fa-trash"
          style={{
            color: '#6D7E8F',
            fontSize: 19,
          }}
          aria-hidden="true"
        />
      ),
      dialogMessage: `Please confirm you want to delete the API Key ${data.name} (ID: ${data.id})`,
      primaryButtonColor: 'error',
      discardLabel: 'Cancel',
      confirmLabel: 'Delete',
      onClick: this._handleDeleteClicked,
    };

    menuItems.push(deleteMenuItem);

    return (
      <div className="detail-actions">
        {showStatus && (
          <div className="status-holder">
            <div className={classnames('status-image-placeholder', statusClass)}>
              <div className="bolt" />
            </div>
          </div>
        )}
        <Menu items={menuItems} />
      </div>
    );
  }

  _handleRotateClicked = () => {
    this.props.rotateApiKey(this.props.data.id);
  };

  _handlePauseClicked = () => {
    this.props.pauseApiKey(this.props.data.id);
  };

  _handleActivateClicked = () => {
    this.props.activateApiKey(this.props.data.id);
  };

  _handleDeleteClicked = () => {
    this.props.deleteApiKey(this.props.data.id);
  };

  _handleOpenDetails = (e) => {
    if (e && typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }
    const { data, onOpenDetailsMenu, openDetailDrawerInPortal, openDetailsModal } = this.props;
    if (typeof onOpenDetailsMenu === 'function') {
      onOpenDetailsMenu(data);
      return;
    }
    if (typeof openDetailsModal === 'function') {
      openDetailsModal(data);
      return;
    }
    if (typeof openDetailDrawerInPortal === 'function') {
      openDetailDrawerInPortal(data, {});
    }
  };
}

APIKeyDetailActions.defaultProps = {
  hideMenuDetails: false,
};

export default APIKeyDetailActions;
